var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FDF7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32H30V26H20V32ZM20 36V42H30V36H20ZM34 42H44V36H34V42ZM44 32V26H34V32H44ZM20 18H44C46.1875 18 48 19.8125 48 22V42C48 44.25 46.1875 46 44 46H20C17.75 46 16 44.25 16 42V22C16 19.8125 17.75 18 20 18Z",
    fill: "#ECB31F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix);
export default __webpack_public_path__ + "static/media/matrix.c7c4590d59a486025311797849f4ae45.svg";
export { ForwardRef as ReactComponent };